//@ts-nocheck
import React, { useState, useEffect } from 'react';
import { Modal, Radio, Input } from '@gamesb42/ui-kit';

import s from './styles.module.scss';

interface EditMonetizationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: any) => void;
  initialValue?: string | string[];
  loading?: boolean;
}

const MONETIZATION_OPTIONS = [
  { label: 'In-app purchase', value: 'In-app purchase' },
  { label: 'Ads', value: 'Ads' },
  { label: 'In-app purchase & Ads', value: 'In-app purchase & Ads' },
  { label: 'Premium', value: 'Premium' },
  { label: 'Subscription', value: 'Subscription' },
];

export function EditMonetizationModal({ isOpen, onClose, onSave, initialValue, loading }: EditMonetizationModalProps) {
  const [selectedValue, setSelectedValue] = useState<string>('');
  const [otherComment, setOtherComment] = useState('');

  useEffect(() => {
    // Initialize values when modal opens
    if (isOpen) {
      if (!initialValue) {
        setSelectedValue('');
        setOtherComment('');
      } else if (Array.isArray(initialValue)) {
        const filtered = initialValue.filter((item) => item !== "I don't know");
        
        // Ищем элемент, который начинается с "Other:"
        const otherItem = filtered.find((item) => item.startsWith('Other:'));
        
        if (otherItem) {
          // Извлекаем комментарий после "Other:"
          const comment = otherItem.replace('Other:', '').trim();
          setOtherComment(comment);
          // Устанавливаем первое значение, которое не является "Other:"
          const nonOtherItem = filtered.find((item) => !item.startsWith('Other:'));
          setSelectedValue(nonOtherItem || '');
        } else {
          setSelectedValue(filtered[0] || '');
          setOtherComment('');
        }
      } else {
        if (initialValue.startsWith('Other:')) {
          const comment = initialValue.replace('Other:', '').trim();
          setOtherComment(comment);
          setSelectedValue('');
        } else {
          setSelectedValue(initialValue === "I don't know" ? '' : initialValue);
          setOtherComment('');
        }
      }
    }
  }, [isOpen, initialValue]);

  const handleRadioChange = (e: any) => {
    setSelectedValue(e.target.value);
  };

  const handleSave = () => {
    const result = {
      monetization: selectedValue,
      otherComment,
    };
    onSave(result);
  };

  const handleCancel = () => {
    setSelectedValue('');
    setOtherComment('');
    onClose();
  };

  return (
    <Modal
      open={isOpen}
      onCancel={handleCancel}
      title="Monetization model of your app/game?"
      okText="Save"
      cancelText="Cancel"
      okButtonProps={{
        onMouseDown: handleSave,
        disabled: loading,
        loading: loading,
      }}
      cancelButtonProps={{
        disabled: loading,
      }}
      width={720}
    >
      <div className={s.modalContent}>
        <Radio.Group value={selectedValue} onChange={handleRadioChange}>
          {MONETIZATION_OPTIONS.map((option) => (
            <div key={option.value} className={s.radioItem}>
              <Radio value={option.value}>{option.label}</Radio>
            </div>
          ))}
        </Radio.Group>

        <div className={s.otherSection}>
          <div className={s.otherLabel}>Other (Add comment)</div>
          <Input.TextArea
            value={otherComment}
            onChange={(e) => setOtherComment(e.target.value)}
            placeholder="Add your comment here..."
            rows={4}
            className={s.otherInput}
          />
        </div>
      </div>
    </Modal>
  );
}
